import {
  ContentfulAccordionPageQuery,
  ContentfulAccordionPageQueryVariables
} from "@outschool/gql-frontend-generated";
import { gql, useQueryWithPreviousData } from "@outschool/ui-apollo";

const CONTENTFUL_ACCORDION_PAGE_QUERY = gql`
  query ContentfulAccordionPage(
    $slug: String!
    $locale: String
    $preview: Boolean!
  ) {
    contentfulAccordionPageCollection(
      limit: 1
      skip: 0
      where: { slug: $slug }
      preview: $preview
      locale: $locale
    ) {
      items {
        title
        showToc
        publishedAt
        headerImage {
          url(transform: { width: 1000 })
          description
          width
          height
        }
        preamble {
          json
        }
        sectionsCollection {
          items {
            heading
            body {
              json
            }
          }
        }
      }
    }
  }
`;

export default function useContentfulAccordionPage({
  slug,
  locale
}: {
  slug: string;
  locale?: string;
}) {
  const response = useQueryWithPreviousData<
    ContentfulAccordionPageQuery,
    ContentfulAccordionPageQueryVariables
  >(CONTENTFUL_ACCORDION_PAGE_QUERY, {
    variables: {
      slug,
      preview: false,
      locale
    },
    fetchPolicy: "network-only"
  });

  return response?.data?.contentfulAccordionPageCollection?.items?.[0];
}
